// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a7c71903","239":"aa2bf5a5","455":"e62d9aa4"}[chunkId] + ".chunk.js";
};